import { type SvgComponentType } from "@newsela/angelou";

export enum InstructionFeatureValuesEnum {
  decodable = "decodable",
  power_words = "power_words",
  formative = "formative",
}

export interface IInstructionalFeatureOption {
  label: string;
  value: InstructionFeatureValuesEnum;
  dataQaSelector: string;
  SvgComponent: SvgComponentType;
}
